var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37565 17.9163C4.66732 17.9163 0.833984 14.083 0.833984 9.37467C0.833984 4.66634 4.66732 0.833008 9.37565 0.833008C14.084 0.833008 17.9173 4.66634 17.9173 9.37467C17.9173 14.083 14.084 17.9163 9.37565 17.9163ZM9.37565 2.08301C5.35065 2.08301 2.08398 5.35801 2.08398 9.37467C2.08398 13.3913 5.35065 16.6663 9.37565 16.6663C13.4007 16.6663 16.6673 13.3913 16.6673 9.37467C16.6673 5.35801 13.4007 2.08301 9.37565 2.08301Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.126 18.7497C17.9677 18.7497 17.8093 18.6913 17.6843 18.5663L16.0177 16.8997C15.776 16.658 15.776 16.258 16.0177 16.0163C16.2593 15.7747 16.6593 15.7747 16.901 16.0163L18.5677 17.683C18.8093 17.9247 18.8093 18.3247 18.5677 18.5663C18.4427 18.6913 18.2843 18.7497 18.126 18.7497Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.c32c4dfd2c3797050969a91efdb7e171.svg";
export { ForwardRef as ReactComponent };